/* eslint-disable unicorn/no-null */
import { Button, List, ListItem } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { IFile } from '@/types';

interface IFileUploadedListProps {
  files: IFile[] | undefined;
  onDelete: (file: IFile) => void;
}

export const FileUploadedList: React.FC<IFileUploadedListProps> = ({
  files = [],
  onDelete,
}): JSX.Element | null => {
  const { t } = useTranslation();

  return files.length > 0 ? (
    <List spacing={3}>
      {/* eslint-disable-next-line unicorn/prefer-spread */}
      {Array.from(files).map((file) => (
        <ListItem
          alignItems="center"
          display="inline-flex"
          justifyContent="space-between"
          key={file.name}
          w="full"
        >
          {file.name}
          <Button
            color="brand.red.light"
            px={0}
            variant="link"
            onClick={(): void => onDelete(file)}
          >
            {t('ACTIONS.DELETE')}
          </Button>
        </ListItem>
      ))}
    </List>
  ) : null;
};
